import { SortDirection } from '@warebee/frontend/data-access-api-graphql';
import _ from 'lodash';
import React from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  HeatmapBucket,
  HeatmapBucketSortDirection,
  HeatmapBucketStatField,
} from '../../common/heatmap.helper';
import HeatmapToolbar, {
  HeatmapToolbarProps,
} from '../../metrics/HeatmapToolbar';
import useSimulationHqMetricDescriptorsMap from '../../metrics/simulationHq/useSimulationHqMetricDescriptors';
import {
  simulationHqHeatmapBuckets,
  simulationHqHeatmapBucketsSortBy,
  simulationHqHeatmapBucketsSortDirection,
  simulationHqHeatmapFilters,
  simulationHqHeatmapPolicyModeEnabled,
  simulationHqMetricHasStats,
  simulationHqMetricSelected,
} from '../store/simulation.hq.heatmap.state';
import { simulationHqTableDataState } from '../store/simulation.hq.state';
import { simulationShowDatasetAsTable } from '../store/simulation.state';
import { HeatmapFilter } from '../store/simulation.types';

export type SimulationHqHeatmapToolbarProps = {
  hasPolicyMode: boolean;
};

const SimulationHqHeatmapToolbar: React.FC<
  SimulationHqHeatmapToolbarProps
> = props => {
  const setMetricId = useSetRecoilState(simulationHqMetricSelected);
  const metric = useRecoilValue(simulationHqMetricSelected);
  const buckets = useRecoilValue(simulationHqHeatmapBuckets);
  const bucketsWithStats = useRecoilValue(simulationHqMetricHasStats);
  const [sortBy, setSortBy] = useRecoilState(simulationHqHeatmapBucketsSortBy);
  const [sortDirection, setSortDirection] = useRecoilState(
    simulationHqHeatmapBucketsSortDirection,
  );
  const [heatmapFilter, setHeatmapFilter] = useRecoilState(
    simulationHqHeatmapFilters,
  );
  const metricDescriptorMap = useSimulationHqMetricDescriptorsMap();
  const metricDescriptor = metricDescriptorMap[metric];

  const setShowTable = useSetRecoilState(simulationShowDatasetAsTable);
  const setHqTableState = useSetRecoilState(simulationHqTableDataState);
  const [policyMode, setPolicyMode] = useRecoilState(
    simulationHqHeatmapPolicyModeEnabled,
  );

  function showFilteredTable(bucket: HeatmapBucket) {
    setHqTableState({
      sortValues: {
        [metricDescriptor.path]: SortDirection.DESC,
      },
      searchValues: {
        [metricDescriptor.path]: bucket.id,
      },
    });
    setShowTable('simulation-hq');
  }

  const toolbarProps: HeatmapToolbarProps = {
    metricDescriptors: metricDescriptorMap as any,
    metricDescriptor: metricDescriptor as any,
    onMetricChange: v => setMetricId(v as any),
    buckets: buckets,
    hasStats: false,

    heatmapFilter: heatmapFilter,
    onHeatmapFilterChange: (value: HeatmapFilter) => setHeatmapFilter(value),
    sortBy: sortBy,
    onSortByChange: (value: HeatmapBucketStatField) => setSortBy(value),

    sortDirection: sortDirection,
    onSortDirectionChange: (value: HeatmapBucketSortDirection) =>
      setSortDirection(value),

    onBucketActionClick: _.noop,
    hasPolicyMode: props.hasPolicyMode,
    policyMode,
    onPolicyModeChange: v => setPolicyMode(v),
  };

  return <HeatmapToolbar {...toolbarProps} />;
};

export default SimulationHqHeatmapToolbar;
